import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import VueResource from 'vue-resource'
import './plugins/moment';


Vue.config.productionTip = false
Vue.use( VueResource)
import GlobalComponents from './globalComponents'
Vue.use(GlobalComponents);





new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
